<template>
  <router-view v-if="state.project.id" />
  <v-skeleton-loader
    v-else
    type="text"
    class="ma-auto"
    width="100%"
    max-width="300px"
  />
</template>

<script>
import store, { state } from '@/store';
import { handleErrors } from '../utils/notifications';
import client from '@/graphql/client';
import events from '@/events';

export default {
  name: 'ProjectWrapper',

  data() {
    return {
      state,
    };
  },

  computed: {
    currentProjectSlug() {
      return this.$route.params.projectSlug;
    },
  },

  watch: {
    currentProjectSlug() {
      this.setProjectData();
    },
  },

  created() {
    this.setProjectData();
  },

  beforeDestroy() {
    store.resetState('project')
  },

  methods: {
    async setProjectData() {
      if (!this.currentProjectSlug) {
        return;
      }

      if (this.currentProjectSlug === 'new-project') {
        this.createNewProject();
        return;
      }
      const {data: { project }} = await client.getProject({ slug: this.currentProjectSlug })

      store.setProject(project);
    },

    async createNewProject() {
      store.resetState('project');
      const { data, errors } = await client.createProject({languageCode: this.$i18n.locale});
      if (errors.length) {
        handleErrors(errors);
        return;
      }

      const project = data.createProject
      store.addProject(project);
      await this.$router.push({
        params: { projectSlug: project.slug },
      });
      events.refetchState.emit();
    },
  },
};
</script>
